import React, { Component, ErrorInfo, PropsWithChildren } from 'react';
import * as Sentry from '@sentry/react';

type State = {
  hasError: boolean;
};

const containerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  padding: '2rem',
  textAlign: 'center',
  fontFamily: 'sans-serif',
};

const headingStyle: React.CSSProperties = {
  fontSize: '1.5rem',
  marginBottom: '1rem',
  color: '#333',
};

const messageStyle: React.CSSProperties = {
  fontSize: '1rem',
  marginBottom: '2rem',
  color: '#666',
  maxWidth: '480px',
};

const buttonStyle: React.CSSProperties = {
  padding: '0.75rem 1.5rem',
  fontSize: '1rem',
  backgroundColor: '#4a90d9',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

export class ErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);

    try {
      Sentry.captureException(error, {
        extra: { componentStack: errorInfo.componentStack },
      });
    } catch {
      // Sentry may not be initialized; swallow silently
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={containerStyle}>
          <h1 style={headingStyle}>Something went wrong</h1>
          <p style={messageStyle}>
            An unexpected error occurred. Please reload the page to try again.
          </p>
          <button
            type="button"
            style={buttonStyle}
            onClick={this.handleReload}>
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
